import './App.css';
import LayoutRoutes from './Routes/routes';


function App() {
  return (
    <LayoutRoutes/>
  );
}

export default App;
